import monthlyAttendnce from '@/api/monthly-attendnce'
import { baseState, baseMutations } from '@/store/mixins'
import Employee from '@/api/employee'
import moment from 'moment'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}
export const mutations = {
  ...baseMutations
}
export const actions = {
  fetch (context, attrubutes = {}) {
    const branchId = attrubutes.branch_id
    const allBranch = Array.isArray(branchId)
      ? branchId.length
        ? undefined
        : true
      : branchId
        ? undefined
        : true

    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        all_branch: allBranch
      },
      attrubutes
    )
    return monthlyAttendnce.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getDepartment (context, data) {
    return monthlyAttendnce.department(data)
  },
  getHoliday (context, params) {
    return monthlyAttendnce.holiday({ params })
  },
  getEmployee (context, attributes = {}) {
    const branchId = attributes.branch_id
    const allBranch = Array.isArray(branchId)
      ? branchId.length
        ? undefined
        : true
      : branchId
        ? undefined
        : true

    return Employee.get({
      params: Object.assign(
        {
          include: 'position,shift',

          fields: {
            setup_staff_information:
              'staff_id,name_en,name_kh,emp_id,gender,phone_number_1,date_of_birth,position_id,shift_id,photo,department_id',
            position: 'position_id,pos_name_en',
            shift: 'shift_id,shift_name,shift_type'
          },
          filter: {
            status_active: 'Active',
            department_id: attributes.department_id
          },
          all_branch: allBranch,
          branch_id: branchId,
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },

  getPosition (context, data) {
    return monthlyAttendnce.position(data)
  },
  getHeader (context, params) {
    return monthlyAttendnce.header({ params })
  },
  exportExcel (context, payload = {}) {
    const branchId = payload.branch_id
    const allBranch = Array.isArray(branchId)
      ? branchId.length
        ? undefined
        : true
      : branchId
        ? undefined
        : true

    const data = Object.assign(
      {
        all_branch: allBranch
      },
      payload
    )
    return monthlyAttendnce.exportExcel(data)
  }
}
